import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 报告
 */
const report = {

  /**
   * 创建报告组
   */
  createReportGroup (companyId, name, displayName) {
    return axios.post(base.report.createReportGroup, utils.postParamsArrayToJsonString({ companyId, name, displayName }))
  },
  /**
   * 修改报告组
   */
  modifyReportGroup (id, name, displayName) {
    return axios.post(base.report.modifyReportGroup, utils.postParamsArrayToJsonString({ id, name, displayName }))
  },
  /**
   * 删除报告组
   */
  deleteReportGroup (id) {
    return axios.post(base.report.deleteReportGroup, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询报告组
   */
  getReportGroups (companyId) {
    return axios.post(base.report.getReportGroups, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 增加自动生成报告配置
   */
  addReportAutomaticGeneratingConfig (companyId, model, baseName, params, loopRegulation, startTime, endTime, groupId) {
    return axios.post(base.report.addReportAutomaticGeneratingConfig, utils.postParamsArrayToJsonString({ companyId, model, baseName, params, loopRegulation, startTime, endTime, groupId }))
  },
  /**
   * 删除自动生成报告配置
   */
  deleteReportAutomaticGeneratingConfig (configId) {
    return axios.post(base.report.deleteReportAutomaticGeneratingConfig, utils.postParamsArrayToJsonString({ configId }))
  },
  /**
   * 查询自动生成报告配置
   */
  getReportAutomaticGeneratingConfigs (companyId, groups) {
    return axios.post(base.report.getReportAutomaticGeneratingConfigs, utils.postParamsArrayToJsonString({ companyId, groups }))
  },
  /**
   * 获取报告列表
   */
  listReport (companyId, groups) {
    return axios.post(base.report.listReport, utils.postParamsArrayToJsonString({ companyId, groups }))
  },
  /**
   * 获取报告内容
   */
  peekReport (id) {
    return axios.post(base.report.peekReport, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 测试报告内容
   */
  testReportByConfig (model, baseName, params, loopRegulation, startTime, endTime) {
    return axios.post(base.report.testReportByConfig, utils.postParamsArrayToJsonString({ model, baseName, params, loopRegulation, startTime, endTime }))
  },
}

export default report